var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.click()}}},[(_vm.svgInline)?_c(_vm.svgInline,{tag:"component",class:'fill-current ' + _vm.svgClass,attrs:{"height":_vm.height,"width":_vm.width}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }